import { GupEntry } from '@/services/gup-entry';
import { clearGupVisit, returnToGup } from '@/lib/gup';
import { Alert, AlertDescription, AlertTitle, Button } from '@opaz/ui-components';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function GupMessage({ entry, message }: { entry: GupEntry; message?: string }) {
  const { t } = useTranslation();
  return (
    <div className="max-w-xl mx-auto px-4 py-12" role="alert">
      <Alert>
        <AlertTitle>{t('gup.blockTitle')}</AlertTitle>
        <AlertDescription>
          {message ?? (entry.block ? t(`gup.blocks.${entry.block}`) : t(`gup.errors.${entry.failure ?? 'failed'}`))}
        </AlertDescription>
      </Alert>
      <div className="mt-6 flex flex-wrap gap-3">
        {entry.visit ? (
          <Button onClick={() => returnToGup(entry.visit!)}>{t('gup.returnToStart')}</Button>
        ) : (
          <Link to="/" onClick={clearGupVisit}>
            {t('gup.leave')}
          </Link>
        )}
      </div>
    </div>
  );
}
